<div class="flex items-center justify-center h-[100%]">
    <button
        type="button"
        class="si-header-item btn btn-circle btn-ghost"
        [attr.aria-label]="ariaLabel()"
        (click)="toggleTheme()"
    >
        <si-icon [icon]="icon()" />
    </button>
</div>
